/** Clave compartida por Productos, Carrito, detalle, categorías y lista mayorista */
export const STORE_THEME_STORAGE_KEY = 'theme';

/** Evento para sincronizar UI que no hereda el tema del DOM (p. ej. tooltip en portal) */
export const STORE_THEME_CHANGE_EVENT = 'privistore-store-theme-change';

function legacyThemeIsDark() {
  const admin = localStorage.getItem('adminDarkMode');
  if (admin === 'true' || admin === 'false') return admin === 'true';

  const newsletter = localStorage.getItem('newsletterDarkMode');
  if (newsletter === 'true' || newsletter === 'false') return newsletter === 'true';

  const wholesale = localStorage.getItem('lm-theme');
  if (wholesale === 'dark' || wholesale === 'light') return wholesale === 'dark';

  return null;
}

export function applyStoreThemeToDocument(isDark) {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
}

export function persistStoreTheme(isDark) {
  try {
    localStorage.setItem(STORE_THEME_STORAGE_KEY, isDark ? 'dark' : 'light');
  } catch (_) {
    /* ignore */
  }
  applyStoreThemeToDocument(isDark);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(STORE_THEME_CHANGE_EVENT));
  }
}

export function readStoreThemeIsDark() {
  if (typeof localStorage === 'undefined') return true;
  const v = localStorage.getItem(STORE_THEME_STORAGE_KEY);
  if (v === 'light') return false;
  if (v === 'dark') return true;
  const legacy = legacyThemeIsDark();
  if (legacy != null) return legacy;
  return true;
}

export function initializeStoreTheme() {
  const isDark = readStoreThemeIsDark();
  persistStoreTheme(isDark);
  return isDark;
}
